<template>
  <div
    class="foodWarehouseindex"
    v-loading.body="listLoading"
  >
    <div class="top">
      <el-col :span="19">
        <el-button
          type="primary"
          size="medium"
          @click="foodWarehouseadd()"
        >添加</el-button>
        <a
          href="https://cdnfile-10043692.file.myqcloud.com/admin/xls/%E9%A3%9F%E6%9D%90%E6%A8%A1%E6%9D%BF.xls"
          target="_blank"
          download="examName"
        >
          <el-button
            type="primary"
            size="medium"
          >下载</el-button>
        </a>
        <el-upload
          class="upload-import"
          :action="uploadPath"
          :data="uploadData"
          :show-file-list='false'
          accept=".xls"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess"
        >
          <el-button
            type="primary"
            size="medium"
          >导入</el-button>
        </el-upload>
        <el-button
          type="danger"
          size="medium"
          @click="deleteMaterialss()"
        >删除</el-button>
        <el-select
          class="filter-item"
          v-model="listQuery.typeId"
          size="medium"
          @change="handleFilter()"
        >
          <el-option
            v-for="item in foodTypeList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-input
          size="medium"
          placeholder="请输入菜品名称"
          v-model.trim="listQuery.searchName"
          @change="handleFilter"
        >
          <el-button
            size="medium"
            slot="append"
            icon="el-icon-search"
            @click="handleFilter"
          ></el-button>
        </el-input>
      </el-col>
    </div>
    <el-table
      stripe
      :data="dataList"
      :height="`${windowHeight-220}px`"
      border
      style="width: 100%"
      @select="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        width="65px"
        :resizable="false"
        fixed
      ></el-table-column>
      <el-table-column
        label="名称"
        show-overflow-tooltip
        width="100"
        fixed
      >
        <template slot-scope="scope">
          <span
            class="link-type"
            @click="foodWarehouseInfo(scope.row.id)"
          >{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="分类"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          {{scope.row.typeName}}
        </template>
      </el-table-column>
      <el-table-column
        label="能量(cal)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.energy}}
        </template>
      </el-table-column>
      <el-table-column
        label="蛋白质(g)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.protein}}
        </template>
      </el-table-column>
      <el-table-column
        label="脂肪(g)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.fat}}
        </template>
      </el-table-column>
      <el-table-column
        label="碳水化合物(g)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.carbohydrate}}
        </template>
      </el-table-column>
      <el-table-column
        label="维生素A(mg)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.vitaminA}}
        </template>
      </el-table-column>
      <el-table-column
        label="硫胺素(mg)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.vitaminB1}}
        </template>
      </el-table-column>
      <el-table-column
        label="核黄素(mg)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.vitaminB2}}
        </template>
      </el-table-column>
      <el-table-column
        label="维生素C(mg)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.vitaminC}}
        </template>
      </el-table-column>
      <el-table-column
        label="维生素E(mg)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.vitaminE}}
        </template>
      </el-table-column>
      <el-table-column
        label="钙(mg)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.ca}}
        </template>
      </el-table-column>
      <el-table-column
        label="铁(mg)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.fe}}
        </template>
      </el-table-column>
      <el-table-column
        label="锌(mg)"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.zn}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="deleteMaterials(scope.row.id)"
            type="text"
            size="small"
          >删除</el-button>
          <el-button
            @click.native.prevent="foodWarehouseeidt(scope.row.id)"
            type="text"
            size="small"
          >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination-container"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="listQuery.pageNo"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="listQuery.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <el-dialog
      title="导入提示"
      :visible.sync="dialogVisible"
      size="tiny"
    >
      <span v-html="dataname"></span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="dialogVisible = false"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  findDicsByCode,
  queryMaterialLst,
  deleteMaterial,
} from "@/api/foodSetting";
import mixin from "@/mixins/windowResize";
export default {
  data() {
    return {
      listQuery: {
        pageNo: 1,
        pageSize: 20,
        searchName: "",
        typeId: "0",
      },
      dataList: [],
      total: null,
      foodTypeList: [],
      mynum: 0,
      selected: [],
      menuIds: "",
      uploadPath: global.BasePath + "structure/dietary/uploadDietaryMaterial",
      uploadData: {
        token: this.$store.getters.token,
      },
      listLoading: false,
      dialogVisible: false,
      dataname: "",
    };
  },
  created() {
    this.queryMaterialLsts();
    if (this.$route.query.mynum) {
      this.mynum = this.$route.query.mynum;
    }
    findDicsByCode("material")
      .then((res) => {
        this.foodTypeList = [{ id: "0", value: "全部食材类型" }];
        for (let i = 0; i < res.data.data.length; i++) {
          this.foodTypeList.push(res.data.data[i]);
        }
      })
      .catch();
  },
  mixins: [mixin],
  methods: {
    //导入
    handleAvatarSuccess(res) {
      if (res.result) {
        this.$message({
          message: "模版导入成功！",
          type: "success",
        });
        this.listLoading = false;
        this.queryMaterialLsts();
      } else {
        this.dialogVisible = true;
        this.dataname = res.msg;
        this.listLoading = false;
        this.queryMaterialLsts();
      }
    },
    beforeAvatarUpload(file) {
      let suffix = file.name.split(".")[file.name.split(".").length - 1];
      if (suffix !== "xls") {
        this.$message.error("请上传后缀为.xls的模版文件!");
        return false;
      } else {
        this.listLoading = true;
      }
    },
    //获取选中
    handleSelectionChange(val) {
      this.selected = val;
      this.menuIds = "";
      for (let i = 0; i < this.selected.length; i++) {
        if (i < this.selected.length - 1) {
          this.menuIds += this.selected[i].id + ",";
        } else {
          this.menuIds += this.selected[i].id;
        }
      }
    },
    //删除多条
    deleteMaterialss() {
      if (this.selected.length == 0) {
        this.$message({ type: "error", message: "请选择需要删除的食材!" });
        return;
      }
      this.$confirm("此操作将永久删除所选食材, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteMaterial(this.menuIds)
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.queryMaterialLsts();
            })
            .catch();
        })
        .catch(() => {});
    },
    //删除单条
    deleteMaterials(id) {
      this.$confirm("此操作将永久删除此食材, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteMaterial(id)
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.queryMaterialLsts();
            })
            .catch();
        })
        .catch(() => {});
    },
    //获取列表
    queryMaterialLsts() {
      queryMaterialLst(this.listQuery)
        .then((res) => res.data)
        .then((data) => {
          this.dataList = data.data.dataList;
          this.total = data.data.pagination.total;
        })
        .catch((err) => {});
    },
    //搜索
    handleFilter() {
      this.listQuery.pageNo = 1;
      this.queryMaterialLsts();
    },
    //切换码数
    handleSizeChange(val) {
      this.listQuery.pageNo = 1;
      this.listQuery.pageSize = val;
      this.queryMaterialLsts();
    },
    //切换页数
    handleCurrentChange(val) {
      this.listQuery.pageNo = val;
      this.queryMaterialLsts();
    },
    //详情
    foodWarehouseInfo(id) {
      this.$router.push({
        path: "foodWarehouseInfo",
        query: { id: id },
      });
    },
    //编辑
    foodWarehouseeidt(id) {
      this.$router.push({
        path: "foodWarehouseeidt",
        query: { id: id },
      });
    },
    //添加
    foodWarehouseadd() {
      this.$router.push({
        path: "foodWarehouseadd",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.foodWarehouseindex {
  padding: 12px;
  .pagination-container {
    margin-top: 10px;
  }
  .top {
    padding-bottom: 10px;
    overflow: hidden;
    .upload-import {
      display: inline-block;
    }
  }
  .img {
    width: 30px;
    height: 30px;
  }
  .link-type {
    cursor: pointer;
    color: #409eff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/foodSetting/foodWarehouseindex.vue